import { LoadingIcon } from '@/components/icons';
import ConditionalWrapper from '@/components/ui/custom/ConditionalWrapper';
import Disabled from '@/components/shared/Disabled';
import Tag, {
  TagColor,
  TagProps,
} from '@/components/ui/custom/dataDisplay/Tag';
import { ClassNameComponent } from '@/utils/ClassNameComponent';
import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { LEI_FELCA } from '@/lib/growthbook';
import { MouseEventHandler } from 'react';
import { twMerge } from 'tailwind-merge';

interface InteractionProps extends Omit<TagProps, 'className' | 'icon'> {
  count: number;
  icon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  color: TagColor;
  isLoading?: boolean;
  onClick?: () => void;
  className?: Pick<ClassNameComponent, 'tag' | 'img'>;
}

export default function Interaction({
  count,
  icon,
  color,
  isLoading,
  className,
  onClick,
  ...props
}: InteractionProps) {
  const isLeiFelca = useFeatureIsOn(LEI_FELCA);
  const Icon = isLoading ? LoadingIcon : icon;
  const handleOnClick: MouseEventHandler<HTMLDivElement> = e => {
    e.stopPropagation();
    e.preventDefault();
    onClick?.();
  };
  return (
    <ConditionalWrapper condition={isLeiFelca} wrapper={<Disabled />}>
      <Tag
        text={String(count)}
        icon={<Icon className={twMerge('w-3.5', className?.img)} />}
        className={{
          base: twMerge(
            '!text-12 py-0.5 px-1.5 gap-0.5 flex-row-reverse !bg-base-100 border',
            onClick && 'cursor-pointer',
            props.loading && 'pointer-events-none',
            className?.tag,
          ),
        }}
        color={color}
        onClick={handleOnClick}
        {...props}
      />
    </ConditionalWrapper>
  );
}
